import * as yup from 'yup';

import { codeValidation } from 'validations/codeValidation';

export const totpLoginSchema = yup.object().shape({
  code: codeValidation,
});
